import clx from 'classnames'
import styles from './Block.css'

const Block = props => {
  const {
    children,
    border,
    className,
    noMarginTop,
    noMarginBottom,
    'data-role': dataRole
  } = props
  return (
    <div
      className={clx(
        styles.Block,
        className,
        { [styles.border]: border },
        { [styles.noMarginTop]: noMarginTop },
        { [styles.noMarginBottom]: noMarginBottom }
      )}
      data-role={dataRole}
    >
      {children}
    </div>
  )
}

Block.defaultProps = {
  border: true
}

export default Block
